<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space change-catalog-title-dialog">
    <sc-dialog-title>
        {{ 'change project title' | translate: ['erp.ui.edit-project.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <sc-padding>
      <div style="width: 520px;">
      <form [formGroup]="formGroup">
        <sc-flex [vertical]="true" [stretchContent]="true">
          <mat-form-field appearance="fill">
            <mat-label>{{ 'Name' | translate: ['erp.entity.project.name', translationService.language]}}</mat-label>
            <input matInput formControlName="name" required="true">
          </mat-form-field>
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          <div>
            <sc-flex>
              <mat-form-field appearance="fill" style="flex-grow: 1;">
                <mat-label>{{ 'Datum Start' | translate: ['erp.entity.project.start-date',
                  translationService.language]}}</mat-label>
                <input matInput [matDatepicker]="picker1" formControlName="startDate" type="date-local">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
              <sc-content-spacer></sc-content-spacer>
              <mat-form-field appearance="fill" style="flex-grow: 1;">
                <mat-label>{{ 'Datum Ende' | translate: ['erp.entity.project.end-date',
                  translationService.language]}}</mat-label>
                <input matInput [matDatepicker]="picker2" formControlName="endDate" type="date-local">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </sc-flex>
          </div>
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          <mat-checkbox name="archived" formControlName="archived">
            {{'archived' | translate: ['erp.entity.project.archived', translationService.language]}}
          </mat-checkbox>
        </sc-flex>
      </form>
    </div>
    </sc-padding>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.edit-project.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="!confirmEnabled">
          {{ 'Übernehmen' | translate: ['erp.ui.add-project.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
